module.exports = __webpack_public_path__ + "static/media/34.8c249501.mp3";